import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_4";
import BlockPrincipal from "../components/block/Block_12";
import BlockSecondary from "../components/block/Block_3";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.[68]}`}
        />
        <BlockPrincipal
          title={'a little about us'}
          subtitle2={rpdata?.dbSlogan?.[3]?.slogan}
          text={rpdata?.dbAbout?.[0]?.text}
          image2={rpdata?.gallery?.[99]}
          image1={rpdata?.gallery?.[11]}
          image3={rpdata?.gallery?.[70]}
          image4={rpdata?.gallery?.[13]}
          corte={rpdata?.gallery}
          listsAbout
        />
        <ValuesOne
          image={rpdata?.gallery?.[9]}
          image1={rpdata?.gallery?.[4]}
          image2={rpdata?.gallery?.[19]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[4]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.[12]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
